var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:'primary-button button ' + (_vm.mclass ? _vm.mclass : ''),attrs:{"to":{ path: '/signup#signup' }}},[_vm._v(" "+_vm._s(_vm.title ? _vm.title : "Regístrate")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }